import api from "../utils/API";

// Base URL for your API
export const campaignService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/campaign", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  createCampaign: async (payload) => {
    try {
      const response = await api.post("/admin/campaign", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  updateCampaign: async (id, payload) => {
    try {
      const response = await api.put(`/admin/campaign/${id}`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  deleteCampaign: async (id) => {
    try {
      const response = await api.delete(`/admin/campaign/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchCampaignById: async (id) => {
    try {
      const response = await api.get(`/admin/campaign/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchCampaignOptions: async () => {
    try {
      const response = await api.get(`/admin/campaign/all`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchActiveCampaignOptions: async () => {
    try {
      const response = await api.get(`/admin/campaign/active`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
